<script>
import ListForm from "../ListForm.vue";
import * as categoryService from "../../service/category.service";
import _ from "lodash";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  components: {
    ListForm,
  },
  data() {
    return {
      value: null,
      listData: [],
      selectedItem: new Object(),
      prevSelectedItem: "{}",
      dataValue: new Object(),
      showListForm: false,
    };
  },
  computed: {
    categoryName() {
      return this.$route.params.categoryName;
    },
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x) => x.active == true).length;
    },
    filteredList() {
      let list = this.listData.filter(
        (x) =>
          x.additionalProp1 &&
          x.additionalProp1[this.item.filterOn] &&
          x.additionalProp1[this.item.filterOn] == this.value
      );
      if (list.length) this.setSelectedItems(list[0]);
      else this.setSelectedItems(new Object());
      return list;
    },
  },
  methods: {
    setSelectedItems(val) {
      this.selectedItem = val;
      if (this.categoryName === "jointhepractice") {
        this.dataValue = this.updtaeAdditionPropValue(val);
      }
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(
        null,
        this.listData,
        this.selectedItem,
        this.prevSelectedItem
      );
    },
    updtaeAdditionPropValue(dataObject) {
      Object.keys(dataObject.additionalProp1).forEach((key) => {
        if (_.has(dataObject, key)) {
          dataObject[key] = dataObject.additionalProp1[key];
        }
      });
      return dataObject;
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId);
      this.setSelectedItems(data);
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>
<template>
  <ListForm
    :style="item.style"
    :class="`col-${item.size} ${item.class}`"
    :item="item"
    :items="item.children"
    :selectedItem="
      categoryName === 'jointhepractice' ? dataValue : selectedItem
    "
    :listItems="listData"
    :prevSelectedItem="prevSelectedItem"
    :setSelectedItems="setSelectedItems"
    :topbarControls="topbarControls"
  />
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
